function qs(sel){ return document.querySelector(sel); }

let temporaryModalTimer = null;

export function showModal(message){
    const modal = qs('#modal');
    const text = qs('#modal-text');
    text.textContent = message || 'Unbekannter Fehler';
    modal.classList.remove('hidden');
}

export function showModalAlert(message){
    const modal = qs('#modalAlert');
    const text = qs('#modalAlert-text');
    text.textContent = message || 'Unbekannter Fehler';
    modal.classList.remove('hidden');
}

export function showTemporaryModal(message, duration = 2500) {
    const modal = qs('#temporary-modal');
    const text = qs('#temporary-modal-text');
    if (!modal || !text) return;

    text.textContent = message;
    modal.classList.remove('hidden');

    clearTimeout(temporaryModalTimer);
    temporaryModalTimer = setTimeout(() => {
        modal.classList.add('hidden');
    }, duration);
}


export function hideModal(){
    qs('#modal').classList.add('hidden');
}
export function hideModalAlert(){
    qs('#modalAlert').classList.add('hidden');
}
document.addEventListener('click', (e) => {
    if (e.target && e.target.id === 'modal-close') hideModal();
    if (e.target && e.target.id === 'modalAlert-close') hideModalAlert();
});
